import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * Mostra l’elenco compagnie e permette di crearne di nuove
 * indicando anche il fuso orario (lista da GET /timezones).
 */
function CompaniesList() {
  const [companies, setCompanies] = useState([]);
  const [timezones, setTimezones] = useState([]);          // NEW  ⬅️
  const [newCompanyName, setNewCompanyName] = useState("");
  const [newCompanyTz, setNewCompanyTz] = useState("UTC"); // NEW  ⬅️
  const [error, setError] = useState("");
  const [reload, setReload] = useState(false);
  const [viewMode, setViewMode] = useState("active");

  /* -------------------------------------------------- */
  /* FETCH                                              */
  /* -------------------------------------------------- */
  useEffect(() => {
    fetchCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  useEffect(() => {
    // carichiamo la lista IANA una sola volta
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/timezones`);
        if (res.ok) {
          const tz = await res.json();
          setTimezones(tz);
        }
      } catch {
        /* silenzio: se fallisce useremo solo 'UTC' */
      }
    })();
  }, []);

  const fetchCompanies = async () => {
    try {
      setError("");
      const token = localStorage.getItem("access_token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/super_admin/companies`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) {
        const dataErr = await res.json();
        throw new Error(dataErr.detail || "Errore nel fetch companies");
      }
      const data = await res.json();
      setCompanies(data);
    } catch (err) {
      setError(err.message);
    }
  };

  /* -------------------------------------------------- */
  /* CREATE COMPANY                                     */
  /* -------------------------------------------------- */
  const handleCreateCompany = async () => {
    if (!newCompanyName.trim()) return;
    try {
      setError("");
      const token = localStorage.getItem("access_token");
      const payload = {
        name: newCompanyName,
        timezone: newCompanyTz || "UTC",
      };

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/super_admin/companies`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) {
        const dataErr = await res.json();
        throw new Error(dataErr.detail || "Errore creazione company");
      }
      setNewCompanyName("");
      setNewCompanyTz("UTC");
      setReload(!reload);
    } catch (err) {
      setError(err.message);
    }
  };

  /* -------------------------------------------------- */
  /* TOGGLE ACTIVE / INACTIVE                           */
  /* -------------------------------------------------- */
  const handleToggleCompany = async (companyId) => {
    try {
      setError("");
      const token = localStorage.getItem("access_token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/super_admin/companies/${companyId}/toggle_active`,
        { method: "PATCH", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) {
        const dataErr = await res.json();
        throw new Error(dataErr.detail || "Errore toggle company");
      }
      setReload(!reload);
    } catch (err) {
      setError(err.message);
    }
  };

  /* -------------------------------------------------- */
  /* RENDER                                             */
  /* -------------------------------------------------- */
  const filteredCompanies = companies.filter((c) =>
    viewMode === "active" ? c.is_active : !c.is_active
  );

  return (
    <div>
      <h1>Gestione Compagnie</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* Creazione nuova Company */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Nome compagnia"
          value={newCompanyName}
          onChange={(e) => setNewCompanyName(e.target.value)}
          style={{ marginRight: "10px" }}
        />

        {/* SELECT Timezone */}
        <select
          value={newCompanyTz}
          onChange={(e) => setNewCompanyTz(e.target.value)}
          style={{ marginRight: "10px" }}
        >
          {/* fallback se fetch /timezones fallisce */}
          {timezones.length === 0 && <option value="UTC">UTC</option>}
          {timezones.map((tz) => (
            <option value={tz} key={tz}>
              {tz}
            </option>
          ))}
        </select>

        <button onClick={handleCreateCompany}>Crea Compagnia</button>
      </div>

      {/* Switch Attive / Inattive */}
      <div style={{ marginBottom: "20px" }}>
        <button
          onClick={() => setViewMode("active")}
          style={{ fontWeight: viewMode === "active" ? "bold" : "normal", marginRight: "10px" }}
        >
          Mostra Attive
        </button>
        <button
          onClick={() => setViewMode("inactive")}
          style={{ fontWeight: viewMode === "inactive" ? "bold" : "normal" }}
        >
          Mostra Inattive
        </button>
      </div>

      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>Timezone</th> {/* NEW */}
            <th>Stato</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {filteredCompanies.map((c) => (
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>{c.name}</td>
              <td>{c.timezone}</td> {/* NEW */}
              <td>{c.is_active ? "Attiva" : "Inattiva"}</td>
              <td>
                <Link to={`${c.id}`}>Vedi Dettagli</Link>
                {" | "}
                {c.is_active ? (
                  <button onClick={() => handleToggleCompany(c.id)}>Disattiva</button>
                ) : (
                  <button onClick={() => handleToggleCompany(c.id)}>Riattiva</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CompaniesList;
